const intlDateTimeFormat = new Intl.DateTimeFormat([], {
	dateStyle: 'short',
	timeStyle: 'medium',
	literal: '.'
});

export default date => intlDateTimeFormat.format(Date.parse(date));
